<template>
	<form @submit.prevent="onSubmit" class="menu-item search">
		<input v-if="showBar" type="text" v-model="text">
		<input v-if="showBar" type="submit" value="Ir" class="submit"/>
		<div v-if="!showBar" class="spacer"></div>
		<i class="fas fa-search" @click="showBar=!showBar"/>
	</form>
</template>
<script>
export default {
  data () {
		return {
			showBar: false,
			text: ""
		}
	},
	methods: {
		onSubmit() {
			this.$router.push({ name: 'searchresults', params: {searchText: this.text }})
		}
	}
}
</script>
<style>
.spacer {
	width: 120px;
}
.search i {
  vertical-align: middle;
  font-size: 18px;
}
form {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
  cursor: pointer;
	width: 120px;
	position: relative;
	margin-left: 10px;
}
.form {
	margin-top: 10px;
}
.search input[type="text"] {
  width: 120px;
  height: 20px;
  border: 1px solid #999999;
  box-sizing: border-box;
  font-family: Raleway;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  margin-right: 10px;
  padding-right: 0px;
	border-radius: 2px;
}
input[type="text"] {
  color: #888888;
	font-family: 'Raleway', sans-serif;
	font-size: 12px;
	letter-spacing: 0.1em;
}
.search input[type="text"]:active,
.search input[type="text"]:focus {
  border: 1px solid #999999;
	width: 120px;
}
.submit {
  position: absolute;
	right: 0px;
	height: 20px;
	background: #000;
	color: #fff;
	font-family: 'Raleway', sans-serif;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: 0.1em;
	border: 2px solid #000;
}
</style>
